"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dist = require("package_ui_ihm/dist");
var _dayjs = _interopRequireDefault(require("dayjs"));
var _isoWeek = _interopRequireDefault(require("dayjs/plugin/isoWeek"));
require("dayjs/locale/fr");
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _reactRouterDom = require("react-router-dom");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : equipmentDetails.js
* Description : Ce fichier contient la définition de la page equipmentDetails 
*               Cette page affiche les informations détaillées d'un produit client
*               Le terme 'equipment' dans le code correspond à un produit client
* Date de création : 30 septembre 2025
*/ /* CSS et assets */ /* Bibliothèques et composants */ // <-- importe la locale
/* Hook */ // définit 'fr' comme locale globale
_dayjs["default"].locale('fr');
_dayjs["default"].extend(_isoWeek["default"]);
var customParseFormat = require("dayjs/plugin/customParseFormat");
_dayjs["default"].extend(customParseFormat);

/**
* EquipmentDetails : affiche la page qui contient les informations détaillées d'un produit client
*                    plusieurs liens permettent de naviguer sur d'autres pages
*
* Type : page 
*
* Parametres : 
*  None
*/
function EquipmentDetails() {
  //Define useParam
  var _useParams = (0, _reactRouterDom.useParams)(),
    id = _useParams.id;

  // Define useState hooks
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    equipment = _useState2[0],
    setEquipment = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    statusEquipment = _useState4[0],
    setStatusEquipment = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    productName = _useState6[0],
    setProductName = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    ptus = _useState8[0],
    setPtus = _useState8[1];
  var _useState9 = (0, _react.useState)([]),
    _useState0 = _slicedToArray(_useState9, 2),
    treatmentParams = _useState0[0],
    setTreatmentParams = _useState0[1];
  var _useState1 = (0, _react.useState)([]),
    _useState10 = _slicedToArray(_useState1, 2),
    treatmentOccurences = _useState10[0],
    setTreatmentOccurences = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isDataLoading = _useState12[0],
    setDataLoading = _useState12[1];
  var _useState13 = (0, _react.useState)((0, _dayjs["default"])()),
    _useState14 = _slicedToArray(_useState13, 2),
    date = _useState14[0],
    setDate = _useState14[1];
  var _useState15 = (0, _react.useState)([]),
    _useState16 = _slicedToArray(_useState15, 2),
    ptuTimeWorking = _useState16[0],
    setPtuTimeWorking = _useState16[1];
  var _useState17 = (0, _react.useState)(1),
    _useState18 = _slicedToArray(_useState17, 2),
    tabNumber = _useState18[0],
    setTabNumber = _useState18[1];
  var _useState19 = (0, _react.useState)(1),
    _useState20 = _slicedToArray(_useState19, 2),
    buttonNumber = _useState20[0],
    setButtonNumber = _useState20[1];
  var _useState21 = (0, _react.useState)(false),
    _useState22 = _slicedToArray(_useState21, 2),
    reload = _useState22[0],
    setReload = _useState22[1];

  // Define useContext hooks
  var _useAuth = (0, _dist.useAuth)(),
    authStatus = _useAuth.authStatus,
    authToken = _useAuth.authToken,
    currentUser = _useAuth.currentUser;
  var _useApi = (0, _dist.useApi)(),
    path = _useApi.path,
    selectedDate = _useApi.selectedDate,
    setSelectedDate = _useApi.setSelectedDate,
    applicationName = _useApi.applicationName;

  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Define functions
  function retrieveData() {
    return _retrieveData.apply(this, arguments);
  }
  function _retrieveData() {
    _retrieveData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var token, headers, resEquipment, dataEquipment, init_date, resTime, dataTime, resPtu, dataPtu, resTreatmentParam, dataTreatmentParam;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Headers
            headers = {
              accept: 'application/json',
              Authorization: token
            }; // Retrieve equipment details
            _context.n = 1;
            return fetch(path + "/api/eq-eqnt/" + id + "/", {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            });
          case 1:
            resEquipment = _context.v;
            _context.n = 2;
            return resEquipment.json();
          case 2:
            dataEquipment = _context.v;
            setStatusEquipment(resEquipment["status"]);
            setEquipment(dataEquipment);
            init_date = (0, _dayjs["default"])(dataEquipment['date_last_synchro'], 'YYYY-MM-DD');
            if (selectedDate == null) {
              if (init_date.isValid()) {
                setDate(init_date);
              }
            } else {
              setDate(selectedDate);
            }
            // Retrieve time working of ptus
            if (!(applicationName === 'BOXIBRAIN')) {
              _context.n = 6;
              break;
            }
            if (!((dataEquipment['version'].startsWith('1') || dataEquipment['version'].startsWith('2')) && !dataEquipment['version'].startsWith('2.1') && dataEquipment['product']['name'] === 'Boxitunnel' || dataEquipment['product']['name'] !== 'Boxitunnel')) {
              _context.n = 5;
              break;
            }
            _context.n = 3;
            return fetch(path + "/api/eq-eqnt/" + id + "/get-ptus-time-working/", {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            });
          case 3:
            resTime = _context.v;
            _context.n = 4;
            return resTime.json();
          case 4:
            dataTime = _context.v;
            setPtuTimeWorking(dataTime);
            _context.n = 6;
            break;
          case 5:
            setPtuTimeWorking([]);
          case 6:
            // Retrieve name of equipment
            setProductName(dataEquipment['product']['name']);
            // Retrieve ptus linked to equipment 
            if (!(applicationName === 'BOXIBRAIN')) {
              _context.n = 9;
              break;
            }
            _context.n = 7;
            return fetch(path + "/api/eq-mole/?equipment_id=" + id, {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            });
          case 7:
            resPtu = _context.v;
            _context.n = 8;
            return resPtu.json();
          case 8:
            dataPtu = _context.v;
            setPtus(dataPtu["results"]);
          case 9:
            _context.n = 10;
            return fetch(path + "/api/eq-trpa/?equipment_id=" + id, {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            });
          case 10:
            resTreatmentParam = _context.v;
            _context.n = 11;
            return resTreatmentParam.json();
          case 11:
            dataTreatmentParam = _context.v;
            setTreatmentParams(dataTreatmentParam["results"]);
            // Dataloading
            setDataLoading(false);
          case 12:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _retrieveData.apply(this, arguments);
  }
  function retrieveTreatmentOccurences() {
    return _retrieveTreatmentOccurences.apply(this, arguments);
  }
  function _retrieveTreatmentOccurences() {
    _retrieveTreatmentOccurences = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var token, treatmentOccurenceList, _iterator, _step, treatmentParam, resTreatmentOccurence, dataTreatmentOccurence, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Pour chaque treatmentParam retrieve TreatmentOccurences
            treatmentOccurenceList = [];
            _iterator = _createForOfIteratorHelper(treatmentParams);
            _context2.p = 1;
            _iterator.s();
          case 2:
            if ((_step = _iterator.n()).done) {
              _context2.n = 6;
              break;
            }
            treatmentParam = _step.value;
            _context2.n = 3;
            return fetch(path + "/api/eq-troc/?treatment_param_id=" + treatmentParam.id, {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 3:
            resTreatmentOccurence = _context2.v;
            _context2.n = 4;
            return resTreatmentOccurence.json();
          case 4:
            dataTreatmentOccurence = _context2.v;
            treatmentOccurenceList = treatmentOccurenceList.concat(dataTreatmentOccurence["results"]);
          case 5:
            _context2.n = 2;
            break;
          case 6:
            _context2.n = 8;
            break;
          case 7:
            _context2.p = 7;
            _t = _context2.v;
            _iterator.e(_t);
          case 8:
            _context2.p = 8;
            _iterator.f();
            return _context2.f(8);
          case 9:
            setTreatmentOccurences(treatmentOccurenceList);
          case 10:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 7, 8, 9]]);
    }));
    return _retrieveTreatmentOccurences.apply(this, arguments);
  }
  var handleDatabase = function handleDatabase(event) {
    event.preventDefault();
    sendRequestToGenerateDatabase();
  };
  function sendRequestToGenerateDatabase() {
    return _sendRequestToGenerateDatabase.apply(this, arguments);
  }
  function _sendRequestToGenerateDatabase() {
    _sendRequestToGenerateDatabase = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var token, response, blob, url, link, _t2;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Download database
            _context3.p = 1;
            _context3.n = 2;
            return fetch(path + "/api/eq-eqnt/" + id + "/generate-db/?version=" + equipment['version'], {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                Authorization: token
              }
            });
          case 2:
            response = _context3.v;
            if (response.ok) {
              _context3.n = 3;
              break;
            }
            throw new Error('Erreur pendant le téléchargement');
          case 3:
            _context3.n = 4;
            return response.blob();
          case 4:
            blob = _context3.v;
            url = window.URL.createObjectURL(blob);
            link = document.createElement('a');
            link.href = url;
            link.download = 'database.db'; // Nom du fichier proposé
            document.body.appendChild(link);
            link.click();

            // Nettoyage
            link.remove();
            window.URL.revokeObjectURL(url);
            _context3.n = 6;
            break;
          case 5:
            _context3.p = 5;
            _t2 = _context3.v;
            console.error('Erreur :', _t2);
            alert('Impossible de télécharger le fichier');
          case 6:
            return _context3.a(2);
        }
      }, _callee3, null, [[1, 5]]);
    }));
    return _sendRequestToGenerateDatabase.apply(this, arguments);
  }
  var handleFiles = function handleFiles(event) {
    event.preventDefault();
    sendRequestToGenerateFiles();
  };
  function sendRequestToGenerateFiles() {
    return _sendRequestToGenerateFiles.apply(this, arguments);
  }
  function _sendRequestToGenerateFiles() {
    _sendRequestToGenerateFiles = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var token, response, blob, url, link, _t3;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Download database
            _context4.p = 1;
            _context4.n = 2;
            return fetch(path + "/api/eq-eqnt/" + id + "/generate-files/", {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: {
                accept: 'application/json',
                //'Content-Type': 'multipart/form-data',  cette ligne ne doit pas être utilisée avec FormData sinon erreur
                Authorization: token
              }
            });
          case 2:
            response = _context4.v;
            if (response.ok) {
              _context4.n = 3;
              break;
            }
            throw new Error('Erreur pendant le téléchargement');
          case 3:
            _context4.n = 4;
            return response.blob();
          case 4:
            blob = _context4.v;
            url = window.URL.createObjectURL(blob);
            link = document.createElement('a');
            link.href = url;
            link.download = 'boxistick_files.zip'; // Nom du fichier proposé
            document.body.appendChild(link);
            link.click();

            // Nettoyage
            link.remove();
            window.URL.revokeObjectURL(url);
            _context4.n = 6;
            break;
          case 5:
            _context4.p = 5;
            _t3 = _context4.v;
            console.error('Erreur :', _t3);
            alert('Impossible de télécharger le fichier');
          case 6:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 5]]);
    }));
    return _sendRequestToGenerateFiles.apply(this, arguments);
  }
  var handleClick = function handleClick(event, number) {
    event.preventDefault();
    setTabNumber(number);
    if (number === 4) {
      setButtonNumber(1);
    }
  };
  var handleButton = function handleButton(event, number) {
    event.preventDefault();
    setButtonNumber(number);
  };

  // Define useEffect hooks
  (0, _react.useEffect)(function () {
    if (authStatus === 200) {
      setDataLoading(true);
      retrieveData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    if (productName !== 'Boxiclean') {
      setSelectedDate(date);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipment, date]);
  (0, _react.useEffect)(function () {
    if (treatmentParams.length !== 0) {
      retrieveTreatmentOccurences();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treatmentParams]);
  (0, _react.useEffect)(function () {
    if (reload === true) {
      retrieveData();
      setReload(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [applicationName === "BOXILUMIX" ? currentUser && (currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_SUPPORT") ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.CompanyBar, {
      name_app: "BOXILUMIX"
    }) : null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.CompanyBar, {
      name_app: "BOXIBRAIN"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.TabC, {
      tabNumber: 1
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: screenWidth > 650 ? 'App' : 'App-ss',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.Container, {
        children: isDataLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: "Chargement des donn\xE9es"
          })
        }) : statusEquipment === 200 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: screenWidth > 650 ? 'flex-row' : null,
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("h1", {
              children: [equipment['product']['name'], " ", equipment["serial_number"], " - ", equipment['identifier']]
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: screenWidth > 650 ? 'flex-row justify-center margin-bottom margin-top' : 'grid-1-1 justify-center margin-bottom margin-top',
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "link-border",
              children: screenWidth > 850 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.BackPage, {
                path: "/equipments",
                children: "Retour \xE0 la liste des produits client"
              }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.BackPage, {
                path: "/equipments",
                children: "Retour"
              })
            }), (productName === 'Boxitunnel' || productName === 'Boxirover') && applicationName === 'BOXIBRAIN' && (currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_SUPPORT") ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "link-border",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                onClick: handleDatabase,
                className: "link clickable",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                  src: _dist.AddIcon,
                  alt: "add_icon",
                  className: "link-img"
                }), screenWidth > 850 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "link-text",
                  children: "G\xE9n\xE9rer base de donn\xE9es locale"
                }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "link-text",
                  children: "G\xE9n\xE9rer DB locale"
                })]
              })
            }) : productName === 'Boxistick' && applicationName === 'BOXIBRAIN' && (currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_SUPPORT") ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "link-border",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                onClick: handleFiles,
                className: "link clickable",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                  src: _dist.AddIcon,
                  alt: "add_icon",
                  className: "link-img"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "link-text",
                  children: "G\xE9n\xE9rer fichiers locaux"
                })]
              })
            }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "link-border",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactRouterDom.Link, {
                to: '/equipments/' + id + "/documentation/",
                className: "link",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                  src: _dist.FileIcon,
                  alt: "file_page_icon",
                  className: "link-img"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "link-text",
                  children: "Documentation"
                })]
              })
            }), productName !== 'Boxiclean' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "link-border",
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactRouterDom.Link, {
                to: '/treatment-params/' + id,
                className: "link",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                  src: _dist.LedIcon,
                  alt: "led_icon",
                  className: "link-img"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "link-text",
                  children: "Traitements disponibles"
                })]
              })
            }) : null]
          }), productName !== 'Boxiclean' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: screenWidth > 1250 ? 'grid-1-1' : screenWidth > 950 ? 'grid-2-1' : null,
            children: screenWidth > 550 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.Table, {
              labels: ['Produit', 'version', "Société", 'Dernière synchronisation', 'Status'],
              datas: [equipment["product"]["name"], equipment["version"], equipment["company"]["name"], equipment["date_last_synchro"], equipment["status"]["name"]]
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.Table, {
              labels: ['Produit', 'version', "Société", 'Synchronisation', 'Status'],
              datas: [equipment["product"]["name"], equipment["version"], equipment["company"]["name"], equipment["date_last_synchro"], equipment["status"]["name"]]
            })
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: screenWidth > 1250 ? 'grid-1-1' : screenWidth > 950 ? 'grid-2-1' : null,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.Table, {
              labels: ['Produit', 'version', "Société", 'Status'],
              datas: [equipment["product"]["name"], equipment["version"], equipment["company"]["name"], equipment["status"]["name"]]
            })
          }), applicationName === 'BOXIBRAIN' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "margin-bottom margin-top",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
              className: "table-cell table-label",
              children: "Configuration du produit client"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.EquipmentConfig, {
              equipment: equipment,
              ptus: ptus,
              setReload: setReload
            })]
          }) : null, applicationName === 'BOXIBRAIN' && productName !== 'Boxiclean' && ptus.length !== 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "margin-bottom margin-top",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
              className: "table-cell table-label",
              children: "Utilisation des PTUs"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.EquipmentPtuUse, {
              ptuTimeWorking: ptuTimeWorking,
              ptus: ptus
            })]
          }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "margin-bottom margin-top",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider["default"], {})
          }), productName !== 'Boxiclean' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: equipment["date_last_synchro"] !== "Aucune synchronisation" ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: screenWidth > 800 ? 'flex-row margin-bottom margin-top' : 'margin-bottom margin-top',
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "margin-right-large",
                  children: screenWidth > 850 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
                    className: "table-cell table-label",
                    children: "Historique par "
                  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                    className: "table-cell table-label",
                    children: "Historique par"
                  })
                }), tabNumber === 4 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: "margin-right-large",
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                    onClick: function onClick(e) {
                      return handleButton(e, 1);
                    },
                    className: buttonNumber === 1 ? 'button clickable button-fixed-size' : 'button-secondary clickable button-fixed-size',
                    children: "jour"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                    className: 'button-inactive clickable button-fixed-size',
                    children: "semaine"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                    className: 'button-inactive clickable button-fixed-size',
                    children: "mois"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                    className: 'button-inactive clickable button-fixed-size',
                    children: "ann\xE9e"
                  })]
                }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: screenWidth > 850 ? 'margin-right-large' : 'margin-right',
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                    onClick: function onClick(e) {
                      return handleButton(e, 1);
                    },
                    className: buttonNumber === 1 ? 'button clickable button-fixed-size' : 'button-secondary clickable button-fixed-size',
                    children: "jour"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                    onClick: function onClick(e) {
                      return handleButton(e, 2);
                    },
                    className: buttonNumber === 2 ? 'button clickable button-fixed-size' : 'button-secondary clickable button-fixed-size',
                    children: "semaine"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                    onClick: function onClick(e) {
                      return handleButton(e, 3);
                    },
                    className: buttonNumber === 3 ? 'button clickable button-fixed-size' : 'button-secondary clickable button-fixed-size',
                    children: "mois"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                    onClick: function onClick(e) {
                      return handleButton(e, 4);
                    },
                    className: buttonNumber === 4 ? 'button clickable button-fixed-size' : 'button-secondary clickable button-fixed-size',
                    children: "ann\xE9e"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.DateFilter, {
                  option: buttonNumber === 1 ? 'day' : buttonNumber === 2 ? 'week' : buttonNumber === 3 ? 'month' : 'year',
                  labelText: "none",
                  selectedDate: date,
                  setSelectedDate: setDate,
                  clearable: false
                })]
              }), tabNumber === 1 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: 'tabs-equipment-history-4',
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    onClick: function onClick(e) {
                      return handleClick(e, 1);
                    },
                    className: screenWidth > 650 ? 'tab-enable' : 'tab-enable-ss',
                    children: "Timeline"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    onClick: function onClick(e) {
                      return handleClick(e, 2);
                    },
                    className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
                    children: "Configuration des Leds"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    onClick: function onClick(e) {
                      return handleClick(e, 3);
                    },
                    className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
                    children: "Logs"
                  }), applicationName === 'BOXIBRAIN' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    onClick: function onClick(e) {
                      return handleClick(e, 4);
                    },
                    className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
                    children: "Data"
                  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    onClick: function onClick(e) {
                      return handleClick(e, 4);
                    },
                    className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
                    children: "Ambient data"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.Timeline, {
                    treatmentOccurences: treatmentOccurences,
                    calendarDate: date,
                    optionDate: buttonNumber
                  })
                })]
              }) : tabNumber === 2 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: 'tabs-equipment-history-4',
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    onClick: function onClick(e) {
                      return handleClick(e, 1);
                    },
                    className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
                    children: "Timeline"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    onClick: function onClick(e) {
                      return handleClick(e, 2);
                    },
                    className: screenWidth > 650 ? 'tab-enable' : 'tab-enable-ss',
                    children: "Configuration des Leds"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    onClick: function onClick(e) {
                      return handleClick(e, 3);
                    },
                    className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
                    children: "Logs"
                  }), applicationName === 'BOXIBRAIN' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    onClick: function onClick(e) {
                      return handleClick(e, 4);
                    },
                    className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
                    children: "Data"
                  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    onClick: function onClick(e) {
                      return handleClick(e, 4);
                    },
                    className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
                    children: "Ambient data"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  children: productName === 'Boxitunnel' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    className: "margin-bottom margin-top",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                      className: "table-cell table-label",
                      children: "Configuration des horaires"
                    }), buttonNumber === 1 ?
                    /*#__PURE__*/
                    //Filtrage par jour
                    (0, _jsxRuntime.jsx)(_dist.LedConfig, {
                      equipment_id: id,
                      date: date.format('YYYY-MM-DD')
                    }) : buttonNumber === 2 ?
                    /*#__PURE__*/
                    //Filtrage par semaine
                    (0, _jsxRuntime.jsx)(_dist.LedConfig, {
                      equipment_id: id,
                      date: "week-" + date.isoWeekday(1).format('YYYY-MM-DD')
                    }) : buttonNumber === 3 ?
                    /*#__PURE__*/
                    //Filtrage par mois
                    (0, _jsxRuntime.jsx)(_dist.LedConfig, {
                      equipment_id: id,
                      date: date.format('YYYY-MM')
                    }) :
                    /*#__PURE__*/
                    //Filtrage par année
                    (0, _jsxRuntime.jsx)(_dist.LedConfig, {
                      equipment_id: id,
                      date: date.format('YYYY')
                    })]
                  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                    children: "Cette fonctionnalit\xE9 n'est pas disponible sur ce produit."
                  })
                })]
              }) : tabNumber === 3 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: 'tabs-equipment-history-4',
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    onClick: function onClick(e) {
                      return handleClick(e, 1);
                    },
                    className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
                    children: "Timeline"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    onClick: function onClick(e) {
                      return handleClick(e, 2);
                    },
                    className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
                    children: "Configuration des Leds"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    onClick: function onClick(e) {
                      return handleClick(e, 3);
                    },
                    className: screenWidth > 650 ? 'tab-enable' : 'tab-enable-ss',
                    children: "Logs"
                  }), applicationName === 'BOXIBRAIN' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    onClick: function onClick(e) {
                      return handleClick(e, 4);
                    },
                    className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
                    children: "Data"
                  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    onClick: function onClick(e) {
                      return handleClick(e, 4);
                    },
                    className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
                    children: "Ambient data"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  children: productName !== 'Boxiclean' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    className: "margin-bottom margin-top",
                    children: [applicationName === 'BOXIBRAIN' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                      className: "table-cell table-label margin-top",
                      children: "Logs maintenance"
                    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                      className: "table-cell table-label margin-top",
                      children: "Logs"
                    }), buttonNumber === 1 ?
                    /*#__PURE__*/
                    //Filtrage par jour
                    (0, _jsxRuntime.jsx)(_dist.EquipmentLog, {
                      equipment_id: id,
                      date: date.format('YYYY-MM-DD')
                    }) : buttonNumber === 2 ?
                    /*#__PURE__*/
                    //Filtrage par semaine
                    (0, _jsxRuntime.jsx)(_dist.EquipmentLog, {
                      equipment_id: id,
                      date: "week-" + date.isoWeekday(1).format('YYYY-MM-DD')
                    }) : buttonNumber === 3 ?
                    /*#__PURE__*/
                    //Filtrage par mois
                    (0, _jsxRuntime.jsx)(_dist.EquipmentLog, {
                      equipment_id: id,
                      date: date.format('YYYY-MM')
                    }) :
                    /*#__PURE__*/
                    //Filtrage par année
                    (0, _jsxRuntime.jsx)(_dist.EquipmentLog, {
                      equipment_id: id,
                      date: date.format('YYYY')
                    })]
                  }) : null
                })]
              }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                  className: 'tabs-equipment-history-4',
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    onClick: function onClick(e) {
                      return handleClick(e, 1);
                    },
                    className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
                    children: "Timeline"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    onClick: function onClick(e) {
                      return handleClick(e, 2);
                    },
                    className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
                    children: "Configuration des Leds"
                  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    onClick: function onClick(e) {
                      return handleClick(e, 3);
                    },
                    className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
                    children: "Logs"
                  }), applicationName === 'BOXIBRAIN' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    onClick: function onClick(e) {
                      return handleClick(e, 4);
                    },
                    className: screenWidth > 650 ? 'tab-enable' : 'tab-enable-ss',
                    children: "Data"
                  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                    onClick: function onClick(e) {
                      return handleClick(e, 4);
                    },
                    className: screenWidth > 650 ? 'tab-enable' : 'tab-enable-ss',
                    children: "Ambient data"
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  children: applicationName === 'BOXIBRAIN' ? (productName === 'Boxitunnel' || productName === 'Boxirover') && ptus.length !== 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    className: "margin-bottom margin-top",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                      className: "table-cell table-label",
                      children: "Data"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.BoxiStatus, {
                      ptus: ptus,
                      date: date.format('YYYY-MM-DD')
                    })]
                  }) : productName === 'Boxistick' && ptus.length !== 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    className: "margin-bottom margin-top",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                      className: "table-cell table-label",
                      children: "Data"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.BoxiStickStatus, {
                      ptu: ptus.at(0),
                      date: date.format('YYYY-MM-DD')
                    })]
                  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                    children: "Cette fonctionnalit\xE9 n'est pas disponible sur ce produit."
                  }) : productName === 'Boxitunnel' || productName === 'Boxirover' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    className: "margin-bottom margin-top",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                      className: "table-cell table-label",
                      children: "Data"
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.BoxiAmbientStatus, {
                      date: date.format('YYYY-MM-DD')
                    })]
                  }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                    children: "Cette fonctionnalit\xE9 n'est pas disponible sur ce produit."
                  })
                })]
              })]
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              children: "Lancer une synchronisation pour acc\xE8der \xE0 l'historique."
            })
          }) : null]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: "Produit client non disponible !"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "flex-row justify-center margin-bottom margin-top",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "link-border",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.BackPage, {
                path: "/equipments",
                children: "Retour \xE0 la liste des produits client"
              })
            })
          })]
        })
      })
    })]
  });
}
var _default = exports["default"] = EquipmentDetails;